<template>
  <div class="suggestions">
    <div class="suggestion-header">
      <div class="suggestion-search">
        <el-input :placeholder="$t('search_suggestion')" v-model="searchTerm" @clear="searchTerm = null" clearable=""> <i slot="prefix" class="el-input__icon el-icon-search"></i> </el-input>
      </div>
    </div>

    <Nodata :title="$t('nodatakeys.suggestions.nodatatitle')" :description="$t('nodatakeys.suggestions.nodatadesc')" anim="holacon-contacts-lottie" :loading="loading" v-if="participants.length == 0 && (searchTerm == null || searchTerm == '')" :button="$t('nodatakeys.suggestions.nodatabutton')" @btnClick="suggestionIdentifier++" />
    <Nodata :title="$t('nodatakeys.suggestions.nofilterdatatitle')" :description="$t('nodatakeys.suggestions.nofilterdatadesc')" anim="holacon-contacts-lottie" :loading="loading" v-if="participants.length == 0 && searchTerm != null && searchTerm != ''" :button="$t('nodatakeys.suggestions.nofilterdatabutton')" @btnClick="searchTerm = null" />
    <div class="suggestion-item" @click="$root.$emit('getProfile', item.id)" v-for="(item, itemIndex) in participants.filter(x => x.id != $store.state.user.id)" :key="item.id + '-suggestion-participant-' + itemIndex">
      <img :src="$imageus + item.image + '?width=150&height=150&mode=cover'" :alt="item.fullName" />
      <div class="suggestion-item-info">
        <div class="suggestion-item-info-fullName">
          {{ item.fullName }}
        </div>
        <div class="suggestion-item-info-title" v-if="item.contactInfo.title != null || item.contactInfo.company != null">
          <span v-if="item.contactInfo.title != null && item.contactInfo.title != ''"> {{ item.contactInfo.title }}</span>
          <span v-if="item.contactInfo.company != null && item.contactInfo.company != ''">@{{ item.contactInfo.company }}</span>
        </div>
      </div>
    </div>

    <infinite-loading :identifier="suggestionIdentifier" @infinite="getData">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading
  },
  data() {
    return {
      loading: false,
      timeout: null,
      participants: [],
      searchTerm: null,
      suggestionIdentifier: new Date()
    };
  },
  methods: {
    async getData($state) {
      this.loading = true;
      var response = await axios.post("Account/GetSuggestions", {
        skip: this.participants.length,
        take: 20,
        searchTerm: this.searchTerm != "" ? this.searchTerm : null
      });
      if (response.data.data.items == null) {
        response.data.data.items = [];
      }
      var dummyList = [];
        dummyList = response.data.data.items;
      this.participants = [...this.participants, ...dummyList];
      if (dummyList.length == 0) $state.complete();
      else $state.loaded();

      this.loading = false;
    }
  },
  watch: {
    searchTerm: async function() {
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(() => {
        this.participants = [];
        this.suggestionIdentifier++;
      }, 300);
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
.suggestions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  .suggestion-header {
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;

    .suggestion-search {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      position: relative;
    }
  }
  .suggestion-item {
    background: #e8ebef;
    border-radius: 12px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    .suggestion-item-info {
      display: flex;
      flex-direction: column;
      .suggestion-item-info-fullName {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        word-break: break-word;
        color: #292f3b;
      }
      .suggestion-item-info-title {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        word-break: break-word;

        color: #505763;
      }
    }
    img {
      width: 48px;
      overflow: hidden;
      height: 48px;
      border: 2px solid #fff;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Suggestions.vue